import { Component, inject, Input } from '@angular/core';

import { MonitoringDashboardSummary } from '../../../../shared/types/monitoring-results.types';
import { EnhancedLoadingService } from '../../../../shared/services/enhanced-loading.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-totalizer',
  imports: [MatProgressBarModule],
  templateUrl: './totalizer.component.html',
  styleUrl: './totalizer.component.scss',
})
export class TotalizerComponent {
  @Input() cultura: string = '';
  @Input() summary: MonitoringDashboardSummary | null = null;
  loading = inject(EnhancedLoadingService).grid$;

  protected formatInteger(value: number | null | undefined): string {
    if (value === null || value === undefined) {
      return '—';
    }

    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  }

  protected formatDecimal(value: number | null | undefined): string {
    if (value === null || value === undefined) {
      return '—';
    }

    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }
}
